<form [formGroup]="vinYearForm">
  <div class="pad-top-20 row">
    <div class="column twelve md-six">
      <div class="sub-header">Year</div>
      <ds-form-control-container
        [labelText]="yearCtrl.valid ? '' : 'Select a Vehicle Year'"
        [control]="vinYearForm.controls['year']"
      >
        <select id="year" class="icon" formControlName="year" data-cy="replaceVehicleYearSelect">
          <!-- <option value="unset" selected disabled>Select a vehicle year</option> -->
          @for (year of years; track year) {
            <option [value]="year">{{ year }}</option>
          }
        </select>
        <span class="icon-chevron-down"></span>
        <ds-form-control-message [control]="vinYearForm.controls['year']"></ds-form-control-message>
      </ds-form-control-container>
    </div>
  </div>

  <div class="pad-top-20 row">
    <div class="column twelve md-six">
      <div class="sub-header">VIN (Vehicle Identification Number)</div>
      <ds-form-control-container
        [labelText]="vinCtrl.valid ? '' : 'Enter VIN'"
        [control]="vinYearForm.controls['vin']"
        [width]="400"
      >
        <input
          id="vin"
          formControlName="vin"
          data-cy="replaceVehicleVinInput"
          (input)="verifyVin()"
        />
        <ds-form-control-message [control]="vinYearForm.controls['vin']"></ds-form-control-message>
        @if (isSameVin) {
          <div class="error-600-text caption">
            {{ sameVINErrorMessage }}
          </div>
        }
      </ds-form-control-container>
    </div>
  </div>

  <div class="error-600-text caption">
    {{ errorMessage }}
  </div>
</form>
